<script type="ts">
    import { connected } from './stores/user';
    import LoginPanel from './components/LoginPanel.svelte';
    import MyNemiPanel from './components/MyNemiPanel.svelte';
</script>

{#if !$connected}
    <LoginPanel/>
{:else}
    <MyNemiPanel/>
{/if}